import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=22c57f4f&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c57f4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c57f4f')) {
      api.createRecord('22c57f4f', component.options)
    } else {
      api.reload('22c57f4f', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=22c57f4f&scoped=true&", function () {
      api.rerender('22c57f4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TnIkpV7BZqlf/JS/comp/SearchFilterTokens.vue"
export default component.exports